import { formatTime } from "../utils/formatTime";

/**
 * Formats the arrival time to a string in the format of "HH:MM AM/PM"
 * Uses `formatTime` internally but is abstracted so we have centralized logic for this and any changes
 * to the format used for Arrival Time can be made in one place.
 */
export function formatArrivalTime(datetime: Date) {
  return formatTime(datetime).toUpperCase();
}
